module.exports = __webpack_public_path__ + "static/media/check.88f1f8a4.svg";